var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconGoogleLogo = function SvgIconGoogleLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M12.702 4.784A7.26 7.26 0 1 0 19.182 13H12a1 1 0 1 1 0-2h8.25a1 1 0 0 1 1 .999 9.26 9.26 0 1 1-2.711-6.537 1 1 0 1 1-1.415 1.414 7.26 7.26 0 0 0-4.422-2.092"
  })));
};
export default SvgIconGoogleLogo;